<div class="insufficient-permissions__card">
  <div class="insufficient-permissions__header">
    <img class="insufficient-permissions__logo" src="{{ logoSrc }}" />
    <span class="insufficient-permissions__title">{{
      "insufficient_permissions.title" | translate
    }}</span>
  </div>

  <div class="insufficient-permissions__message">
    <div class="insufficient-permissions__icon-container">
      <span class="cross-sign">
        <div class="cross-sign__stem"></div>
        <div class="cross-sign__stem right"></div>
      </span>
    </div>
    <div class="insufficient-permissions__text">
      {{ "insufficient_permissions.message" | translate }}
    </div>
  </div>
  <div>
    <app-button
      class="insufficient-permissions__button"
      (appButtonClick)="goToUserProfileApplication()"
      color="primary"
      size="button--extra-wide"
      buttonTextTranslationKey="insufficient_permissions.button"
      type="stroked-button"
    ></app-button>
  </div>
</div>
<div class="main__footer">
  <app-footer></app-footer>
</div>
